import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface DashboardAgent {
  agent_id: string;
  app_id: string;
  app_name?: string | null;
  is_active: boolean;
  is_running: boolean;
  trigger_interval: string;
  next_trigger_at?: string | null;
  last_triggered_at?: string | null;
}

export interface DashboardRun {
  run_id: string;
  agent_id: string;
  app_id: string;
  status: string;
  error?: string | null;
  created_at: string;
}

export interface DashboardSync {
  job_id: string;
  status: string;
  mode: string;
  created_at: string;
}

export interface DashboardResponse {
  pending_approval: number;
  created_today: number;
  failed_runs_today: number | null;
  last_sync: DashboardSync | null;
  agents: DashboardAgent[];
  recent_failures: DashboardRun[];
}

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private http = inject(HttpClient);

  load(): Observable<DashboardResponse> {
    return this.http.get<DashboardResponse>(`${environment.apiUrl}/agents/dashboard`);
  }
}
